var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { title: _vm.title } },
    [
      _vm.isLoading
        ? _c("feather-icon", {
            staticClass: "spinner",
            attrs: { icon: "SettingsIcon", size: "15" }
          })
        : _vm._e(),
      !_vm.isLoading
        ? _c("app-echart-bar", {
            attrs: { "option-data": _vm.option },
            on: { click: _vm.handleClick }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }